import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { GlobalsService } from '../../../../shared/services/globals.service';
import { DispatchBoardService } from '../../../../shared/services/dispatch-board.service';
import { DispatchDropLocation } from '../../../../shared/models/DispatchDropLocation';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'cp-tech-calendar',
    templateUrl: './tech-calendar.component.html',
    styleUrls: ['./tech-calendar.component.scss'],
    standalone: false
})
export class TechCalendarComponent implements OnInit {

    subscriptions: Subscription[] = [];
    @ViewChild('scrollingThing') public scrollingThing: HTMLElement;

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) {
        this.subscriptions.push(svc_data.calendarWeekData$.subscribe(
            calendar => {
                this.calendarWeek = calendar;
            }));
        this.subscriptions.push(svc_data.calendarSingleDay$.subscribe(
            day => {
                this.calendarDay.day = day;

            }));

        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                //this.initData();
            }));
    }

    timer: any;

    scrollDiv(elementToScroll: any, depl) {
        elementToScroll.nativeElement.scrollTop -= depl;
        console.log('scrolling...')
        this.timer = setTimeout(() => {
            this.scrollDiv(elementToScroll, depl)
        }, 30);
    }

    stopTimer(timer: number) {
        clearTimeout(timer);
    }

    @Input() techData: any = {};
    @Input() singleDay?: boolean = true;

    mouseDown: boolean = false;

    objectKeys = Object.keys;
    calendarWeek: any = {
        sun: new Date(),
        mon: new Date(),
        tue: new Date(),
        wed: new Date(),
        thu: new Date(),
        fri: new Date(),
        sat: new Date()
    };

    calendarDay: any = {
        day: new Date()
    };

    hours: any = [
        new Date().setHours(0, 0, 0, 0),
        new Date().setHours(1, 0, 0, 0),
        new Date().setHours(2, 0, 0, 0),
        new Date().setHours(3, 0, 0, 0),
        new Date().setHours(4, 0, 0, 0),
        new Date().setHours(5, 0, 0, 0),
        new Date().setHours(6, 0, 0, 0),
        new Date().setHours(7, 0, 0, 0),
        new Date().setHours(8, 0, 0, 0),
        new Date().setHours(9, 0, 0, 0),
        new Date().setHours(10, 0, 0, 0),
        new Date().setHours(11, 0, 0, 0),
        new Date().setHours(12, 0, 0, 0),
        new Date().setHours(13, 0, 0, 0),
        new Date().setHours(14, 0, 0, 0),
        new Date().setHours(15, 0, 0, 0),
        new Date().setHours(16, 0, 0, 0),
        new Date().setHours(17, 0, 0, 0),
        new Date().setHours(18, 0, 0, 0),
        new Date().setHours(19, 0, 0, 0),
        new Date().setHours(20, 0, 0, 0),
        new Date().setHours(21, 0, 0, 0),
        new Date().setHours(22, 0, 0, 0),
        new Date().setHours(23, 0, 0, 0)
    ]

    findWeekday(day: Date) {
        let weekDay = "Sunday";

        switch (day.getDay()) {
            case 0:
                //nothing needed
                break;
            case 1:
                weekDay = "Monday";
                break;
            case 2:
                weekDay = "Tuesday";
                break;
            case 3:
                weekDay = "Wednesday";
                break;
            case 4:
                weekDay = "Thursday";
                break;
            case 5:
                weekDay = "Friday";
                break;
            case 6:
                weekDay = "Saturday";
                break;
        }
        return weekDay;
    }

    ngOnInit() {

        this.calendarDay.day = new Date();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    dropOnHour(day, hour) {

    }

    mouseUp(dropLoc: DispatchDropLocation) {
        if (!this.mouseDown) {

            dropLoc.tech = { personId: null };
            dropLoc.tech.personId = this.techData.personId;
            this.svc_data.dispatchDropped(dropLoc);
        }
        this.mouseDown = false;
    }
}
